import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import getArticles from '../services/articles/getArticles';
import createArticle from '../services/articles/createArticle';
import updateArticle from '../services/articles/updateArticle';

// THUNKS
export const fetchArticles = createAsyncThunk('articles/getArticles', getArticles.handler);
export const addArticle = createAsyncThunk('articles/createArticle', createArticle.handler);
export const editArticle = createAsyncThunk('articles/updateArticle', updateArticle.handler);

const initial_state = {
  lists: [],
  loading: false,
  creating: false,
  updating: false,
  initialized: false,
};

const slice = createSlice({
  name: 'articles',
  initialState: initial_state,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchArticles.pending, getArticles.pending)
      .addCase(fetchArticles.fulfilled, getArticles.fulfilled)
      .addCase(fetchArticles.rejected, getArticles.rejected)

      .addCase(addArticle.pending, createArticle.pending)
      .addCase(addArticle.fulfilled, createArticle.fulfilled)
      .addCase(addArticle.rejected, createArticle.rejected)

      .addCase(editArticle.pending, updateArticle.pending)
      .addCase(editArticle.fulfilled, updateArticle.fulfilled)
      .addCase(editArticle.rejected, updateArticle.rejected)
  },
});

const { reducer } = slice;
export default reducer;
